import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=5f7efbde&scoped=true"
import script from "./vat.vue?vue&type=script&lang=js"
export * from "./vat.vue?vue&type=script&lang=js"
import style0 from "./vat.vue?vue&type=style&index=0&id=5f7efbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7efbde",
  null
  
)

export default component.exports